import axios from 'axios';
import { API_URL } from '../config';
import { BLOCKED_UPLOAD_ERROR_CODE } from '../constants';
import { getToken } from '../helpers/common';

const axiosWithoutHumps = axios.create();

export const postAttachments = (files, recaptchaToken) => {
  const data = new FormData();
  [].concat(files).forEach((file) => {
    data.append('attachments[]', file);
  });

  if (recaptchaToken) {
    data.append('g-recaptcha-response', recaptchaToken);
  }

  return axiosWithoutHumps
    .post(`${API_URL}/claim-attachment`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((res) => {
      if (!(res.data instanceof Array) || res.data.some((value) => !value.uuid)) {
        const error = new Error();
        error.message = `Unexpected response, expected [{ uuid: ... }], got: ${res.data}`;
        error.code = BLOCKED_UPLOAD_ERROR_CODE;
        throw error;
      }
      return res.data;
    });
};

export const postAttachment = (file, recaptchaToken) => (
  postAttachments([].concat(file), recaptchaToken).then((data) => data[0])
);

export const postError = (error, metadata) => axios.post(`${API_URL}/claim-attachment/error`, { frontendError: error, metadata });
export const uploadFormData = (URl, formData) => {
  axiosWithoutHumps.post(URl, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${getToken()}`,
    },
  });
};
